import { Box, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import { debounce, isArray } from 'lodash';
import React, { useEffect } from 'react'
import { FieldValues, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';
import { VerificationAgencyClientService } from '../../../Component/Api/VerificationAgency/VerificationAgencyClient/VerificationAgencyClientService';
import { VerificationCompanyAtom } from '../../../State/VerificationCompany.Atom';
import {
    VerificationAgencyClientApplication
} from "../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClientApplication";
import {
    VerificationAgencyClientApplicationService
} from "../../../Component/Api/VerificationAgency/VerificationAgencyClientApplication/VerificationAgencyClientApplicationService";
import { LoadingButton } from "@mui/lab";
import { useHistory } from "react-router-dom";
import { CustomDialogTitle } from "../../Common/Custom/CustomDialogTitle";
import { verificationAgency } from '../../../Component/Common/Constants/routes';
import { VAClientData } from '../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClient';
import { IDropDownOptionsWithDescription } from '../../../Component/Common/Components/FormValidationInputs/AppSelectListWithInfo';
import AutocompleteWithInfo from '../../../Component/Common/Components/Autocomplete/AutocompleteWithInfo';

interface IApplicationModalProps {
    showApplicationDataModal: boolean;
    closeApplicationDataModal: () => void;
}


export const ApplicationDataModal = (props: IApplicationModalProps) => {

    const history = useHistory();
    const [company, setCompany] = useRecoilState(VerificationCompanyAtom);
    const [loading, setLoading] = React.useState(false);
    const [vaClients, SetVAClients] = React.useState<IDropDownOptionsWithDescription[]>([]);

    const { control, handleSubmit, formState: { isSubmitting }, reset, watch } = useForm({
        mode: 'all',
    });

    const [clientName, setClientName] = React.useState<string>("");

    const handleDataSubmit = async (data: FieldValues) => {
        try {
            const requestData = {
                vaClientId: data.company.id,
            } as VerificationAgencyClientApplication.ClientApplicationDetailsDto;

            const result = await VerificationAgencyClientApplicationService.CreateEntry(requestData);

            toast.success(`Application created`);
            setCompany({ vaClientId: data.company.id, applicationId: result.data.vaClientApplicationId, company: data.company.value, feedbackId: -1, registrationNumber: data.registrationNumber, vatNumber: data.vatNumber });
            history.push(`/${verificationAgency.company}/${verificationAgency.applications}/serviceRequired`);
        } catch (error: any) {
            console.log(error);
            if (isArray(error)) {
                let Errors: string[] = error;
                Errors.forEach((error: string) => {
                    toast.error(error);
                });
            }
        }
    }

    const getClients = async (name: string) => {
        setLoading(true);
        try {
            const response = await VerificationAgencyClientService.GetClientNames(name);

            const formattedClients = response.data.map((client: VAClientData) => {

                const registrationNumber = client.registrationNumber ?? "Not Specified";
                const vatNumber = client.vatNumber ?? "Not Specified";
                const description = `(Reg: ${registrationNumber}, VAT: ${vatNumber})`;
    
                return {
                    id: client.vaClientId,
                    value: client.companyName,
                    description: description,
                };
            });

            SetVAClients(formattedClients);
        } catch (error) {
            console.log(error);
        }
        finally {
            setLoading(false);
        }
    }

    const debouncedGetClients = React.useRef(debounce((value: string) => {
        getClients(value);
    }, 300));

    const handleInputFieldChange = (value: string) => {
        setClientName(value);
        debouncedGetClients.current(value);
    }

    useEffect(() => {
        getClients(clientName);
    }, [])

    return (
        <Dialog disableEnforceFocus open={props.showApplicationDataModal} onClose={() => { props.closeApplicationDataModal() }} aria-labelledby="form-dialog-title" maxWidth='sm' fullWidth>
            <CustomDialogTitle id="customized-dialog-title" onClose={() => props.closeApplicationDataModal()}>
                Add Application
            </CustomDialogTitle>
            <DialogContent>
                <Box>
                    <form id='ApplicationDetailsForm' onSubmit={handleSubmit(handleDataSubmit)}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} mt={1}>
                                <AutocompleteWithInfo
                                    control={control}
                                    name="company"
                                    label="Company Name"
                                    items={vaClients}
                                    size="small"
                                    onInputFieldChange={handleInputFieldChange}
                                    useManualFiltering={true}
                                    loading={loading}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            </DialogContent>
            <DialogActions>
                <LoadingButton 
                    loading={isSubmitting} 
                    variant='contained' 
                    type="submit" 
                    form='ApplicationDetailsForm' 
                    color='primary'
                    disabled={!watch("company")}
                    >
                        Add
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}
